let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kAg8V")).then(() => parcelRequire('f4vYC'));